import {
  Company,
  FILTERS
} from '../const';
import {
  scrollById
} from '../utils';

export class FilterMap {

  constructor(cls, objectManager, data) {
    this.container = document.querySelector(cls);
    this.elem = this.findFilter();
    this.objectManager = objectManager;
    this.data = data;
    this.callback = {};

    this.elemChangeHandler = this.elemChangeHandler.bind(this);
    this.elem.addEventListener('change', this.elemChangeHandler);

    this.show();
  }

  getElem() {
    return this.elem;
  }

  elemChangeHandler(evt) {
    const label = this.changeHandler(evt);
    this.filter(label);
  }

  setCategory(category) {
    const id = this.getId(category);
    this.setOption(id);
    this.filter(category);
    scrollById(`#map`, 110);
  }

  getCategory(id) {
    switch (id) {
      case 'filter13':
        return Company.CDEK;
      case 'filter19':
        return Company.OZON;
      case 'filter18':
        return Company.POSTAMAT;
      default:
        return 'Все';
    }
  }

  setElemChangeHandler(callback) {
    this.callback.change = callback;
  }

  filter(category) {
    this.filterByCategory(category);
    if ('change' in this.callback) {
      this.callback.change(category, this.getFilterFunction(FILTERS));
    }
  }

  filterByCategory(category) {
    if (category === 'Все') {
      this.resetFilters();
    } else {
      this.checkFilter(category);
    }
  }

  resetFilters() {
    for (let key in FILTERS) {
      if (FILTERS.hasOwnProperty(key)) {
        FILTERS[key] = true;
      }
    }
  }

  checkFilter(category) {
    for (let key in FILTERS) {
      if (FILTERS.hasOwnProperty(category)) {
        if (key === category) {
          FILTERS[key] = true;
        } else {
          FILTERS[key] = false;
        }
      }
    }
  }

  getFilterFunction(categories) {
    return function (obj) {
      var content = obj.properties.hintContent;
      return categories[content];
    };
  }

  show() {
    const array = this.data.features.map((item) => item.properties.hintContent);
    const set = new Set(array);

    if (set.size > 1) {
      let setId = new Set();
      set.forEach((category) => {
        const id = this.getId(category);
        setId.add(id);
      });
      this.changeOptionClass(setId);
      this.container.classList.add('show');
    }
  }

  getId(category) {
    switch (category) {
      case Company.CDEK:
        return 'filter13';
      case Company.OZON:
        return 'filter19';
      case Company.POSTAMAT:
        return 'filter18';
      default:
        throw new Error(`${category} Неизвестная категория`);
    }
  }

  activeOption(set, id, option) {
    if (set.has(id)) {
      option.classList.add('active');
    }
  }
}

export class FilterList extends FilterMap {
  findFilter() {
    if (this.container.tagName === 'UL') {
      return this.container;
    } else {
      return this.container.querySelector('ul');
    }
  }
  changeHandler(evt) {
    const item = evt.target.closest('li');
    if (!item) {
      return;
    }
    const id = item.querySelector('input').id;
    const category = this.getCategory(id);
    return category;
  }

  changeOptionClass(set) {
    const options = this.elem.querySelectorAll('li');
    Array.from(options).forEach((option) => {
      const id = option.querySelector('input').id;
      this.activeOption(set, id, option);
    });
  }

  setOption(id) {
    const input = this.elem.querySelector(`#${id}`);
    input.checked = true;
  }
}

export class FilterSelect extends FilterMap {
  findFilter() {
    if (this.container.tagName === 'SELECT') {
      return this.container;
    } else {
      return this.container.querySelector('select');
    }
  }
  changeHandler(evt) {
    const id = evt.currentTarget.value;
    const category = this.getCategory(id);
    return category;
  }

  changeOptionClass(set) {
    const options = this.elem.options;
    Array.from(options).forEach((option) => {
      const value = option.value;
      this.activeOption(set, value, option);
    });
  }

  setOption(id) {
    this.elem.value = id;
  }
}
